module.exports = __webpack_public_path__ + "static/searchFormHorizontalFront-dbae9bc7702ee0f61721bef8e5deab24.png";